import { useDispatch } from 'react-redux';
import {
	Col,
	Alert,
	Spinner,
	Row,
	Card,
	CardHeader,
	CardBody,
} from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getMeasurementQuery } from '../../../slices/dataProviders/thunk';
import { Link } from 'react-router-dom';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import OffcanvasContainer from './OffcanvasContainer';
import Section from './Section';
import MeasurementDetailModal from './MeasurementDetailModal';

const MeasurementList = () => {
	const [dataMeasurement, setDataMeasurement] = useState({});

	const [modalView, setModalView] = useState(false);

	function handleToggleModalView() {
		setModalView(!modalView);
	}

	// View Data
	const handleClickView = measurement => {
		setDataMeasurement(measurement);
		setModalView(true);
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones',
				enableSorting: false,
				enableColumnFilter: false,
				enableGlobalFilter: false,
				enableColumnActions: false,
				accessorKey: 'measurement',
				columnDefType: 'display',
				align: 'center',
				size: 'auto',
				Cell: cellProps => {
					return (
						<div className='d-flex'>
							<div className='flex-shrink-0' style={{ width: '100%' }}>
								<ul className='list-inline mb-0'>
									<li className='list-inline-item'>
										<Link
											onClick={e => {
												e.preventDefault();
												handleClickView(cellProps.row.original);
											}}
										>
											<i className={`${Icons.idCard} align-bottom text-muted`}></i>
										</Link>
									</li>
								</ul>
							</div>
						</div>
					);
				},
			},
			{
				header: 'Código SIEP',
				accessorKey: 'siep_code',
				dataType: 'multi-select',
				align: 'center',
			},
			{
				header: 'Región',
				accessorKey: 'region_centro',
				dataType: 'multi-select',
				titlecase: true,
				align: 'center',
			},
			{
				header: 'Barrio',
				accessorKey: 'barrio_centro',
				dataType: 'multi-select',
				align: 'center',
			},
			{
				header: 'Establecimiento',
				accessorKey: 'nombre_centro',
				dataType: 'multi-select',
				titlecase: true,
				align: 'center',
			},
			{
				header: 'Titular',
				accessorKey: 'titular_centro',
				dataType: 'multi-select',
				titlecase: true,
				align: 'center',
			},
			{
				header: 'Fecha',
				accessorKey: 'timestamp_clp',
				dataType: 'datetime',
				defaultSort: 'desc',
				align: 'center',
			},
			{
				header: 'Profundidad',
				accessorKey: 'depth',
				dataType: 'multi-select',
				align: 'center',
			},
			{
				header: 'Posición',
				accessorKey: 'position',
				dataType: 'multi-select',
				titlecase: true,
				align: 'center',
			},
			{
				header: 'Min. Oxígeno',
				accessorKey: 'min_oxygen',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
			{
				header: 'Max. Oxígeno',
				accessorKey: 'max_oxygen',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
			{
				header: 'Prom. Oxígeno',
				accessorKey: 'avg_oxygen',
				dataType: 'float.2',
				align: 'center',
			},
			{
				header: 'Std. Dev. Oxígeno',
				accessorKey: 'stddev_oxygen',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
			{
				header: 'Min. Saturación',
				accessorKey: 'min_saturation',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
			{
				header: 'Max. Saturación',
				accessorKey: 'max_saturation',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
			{
				header: 'Prom. Saturación',
				accessorKey: 'avg_saturation',
				dataType: 'float.2',
				align: 'center',
			},
			{
				header: 'Std. Dev. Saturación',
				accessorKey: 'stddev_saturation',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
			{
				header: 'Min. Temperatura',
				accessorKey: 'min_temperature',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
			{
				header: 'Max. Temperatura',
				accessorKey: 'max_temperature',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
			{
				header: 'Prom. Temperatura',
				accessorKey: 'avg_temperature',
				dataType: 'float.2',
				align: 'center',
			},
			{
				header: 'Std. Dev. Temperatura',
				accessorKey: 'stddev_temperature',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
			{
				header: 'Min. Salinidad',
				accessorKey: 'min_salinity',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
			{
				header: 'Max. Salinidad',
				accessorKey: 'max_salinity',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
			{
				header: 'Prom. Salinidad',
				accessorKey: 'avg_salinity',
				dataType: 'float.2',
				align: 'center',
			},
			{
				header: 'Std. Dev. Salinidad',
				accessorKey: 'stddev_salinity',
				dataType: 'float.2',
				visible: false,
				align: 'center',
			},
		],
		[]
	);

	return (
		<React.Fragment>
			<ODataGrid
				getDataFunc={getMeasurementQuery}
				columns={columns}
				remoteOperations={{
					pagination: true,
					sorting: true,
					filtering: true,
				}}
				defaultPageSize={20}
			/>
			<MeasurementDetailModal
				measurement={dataMeasurement}
				isOpen={modalView}
				handleToggleModal={handleToggleModalView}
			/>
		</React.Fragment>
	);
};

export default MeasurementList;
